<script lang="ts" setup>
import TwoFactorAuthenticationForm from "@/components/TwoFactorAuthenticationForm.vue";

let props = defineProps({
    authKey: {
        type: String,
        default: null
    },
});

</script>
<template>
    <div class="authorization flex-column items-center">
        <div class="authorization_popup-title headline-m">Two-Factor Authentication</div>
        <TwoFactorAuthenticationForm style="width:50%" :authKey="props.authKey"/>
    </div>
</template>